#import "./TrainingModuleAdminFields.graphql"

query GetTrainingModule($id: ID!) {
  trainingModule(id: $id) {
    ...TrainingModuleAdminFields
  }
}
